export const lists = [
  { id: 'nav1', name: '회사소개', direction: '/about' },
  { id: 'nav2', name: '제품소개', direction: '/products' },
  { id: 'nav3', name: '공지사항', direction: '/notification' },
  { id: 'nav4', name: '판매업체', direction: '/seller' },
  { id: 'nav5', name: '미디어자료', direction: '/media' },
];
